import React from 'react';
import './index.less';
import bgImg from 'assets/img/main_bg.jpg';

function Background(props: { style?: React.CSSProperties }) {
    return (
        <div className="background" style={props.style}>
            <img src={bgImg} title="" alt="" className="background-img" />
        </div>
    );
}

export default React.memo(Background);
